import { createFileRoute } from '@tanstack/react-router';
import { CohortForm } from '@/components/cohorts/CohortForm.tsx';
import { useActiveOrganisation } from '@/lib/activeOrganisation.ts';

export interface CohortCreateSearch {
  /** Comes from a track's page: "add a cohort to this track". */
  track_id?: string;
}

export const Route = createFileRoute('/_app/cohorts/create')({
  staticData: { orgScope: 'required' },
  validateSearch: (search: Record<string, unknown>): CohortCreateSearch => ({
    track_id: typeof search.track_id === 'string' ? search.track_id : undefined,
  }),
  component: CreateCohortPage,
});

/* A new cohort belongs to the organisation this session is looking through. */
function CreateCohortPage() {
  const { track_id: trackId } = Route.useSearch();
  const { organisation } = useActiveOrganisation();

  return (
    <CohortForm organisationId={organisation?.id ?? null} initialTrackId={trackId} />
  );
}
